"use strict";
/**
 * Copyright 2019 the orbs-ethereum-contracts authors
 * This file is part of the orbs-ethereum-contracts library in the Orbs project.
 *
 * This source code is licensed under the MIT license found in the LICENSE file in the root directory of this source tree.
 * The above notice should be included in all copies or substantial portions of the software.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrbsTokenService = void 0;
var mainnetAddresses_1 = require("../mainnetAddresses");
var ERC20_json_1 = __importDefault(require("@orbs-network/orbs-ethereum-contracts-v2/build/contracts/ERC20.json"));
var erc20EventsUtils_1 = require("../../utils/erc20EventsUtils");
var MAIN_NET_ERC_TOKEN_ADDRESS = mainnetAddresses_1.ORBS_MAIN_NET_CONTRACT_ADDRESSES.ercToken;
var OrbsTokenService = /** @class */ (function () {
    function OrbsTokenService(web3, erc20address) {
        if (erc20address === void 0) { erc20address = MAIN_NET_ERC_TOKEN_ADDRESS; }
        this.web3 = web3;
        this.erc20TokenContract = new this.web3.eth.Contract(ERC20_json_1.default.abi, erc20address);
    }
    // CONFIG //
    OrbsTokenService.prototype.setFromAccount = function (address) {
        this.erc20TokenContract.options.from = address;
    };
    // READ //
    OrbsTokenService.prototype.readBalance = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var balance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.erc20TokenContract.methods.balanceOf(address)];
                    case 1:
                        balance = _a.sent();
                        return [2 /*return*/, BigInt(balance)];
                }
            });
        });
    };
    OrbsTokenService.prototype.readAllowance = function (ownerAddress, spenderAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var allowanceStr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.erc20TokenContract.methods.allowance(ownerAddress, spenderAddress).call()];
                    case 1:
                        allowanceStr = _a.sent();
                        return [2 /*return*/, BigInt(allowanceStr)];
                }
            });
        });
    };
    // SUBSCRIPTIONS //
    OrbsTokenService.prototype.subscribeToAllowanceChange = function (ownerAddress, spenderAddress, callback) {
        var _this = this;
        var specificEventEmitter = this.erc20TokenContract.events.Approval({
            filter: {
                owner: [ownerAddress],
                spender: [spenderAddress],
            },
        }, function (error, event) { return __awaiter(_this, void 0, void 0, function () {
            var newAllowance;
            return __generator(this, function (_a) {
                if (error) {
                    callback(error, BigInt(0));
                    return [2 /*return*/];
                }
                newAllowance = event.returnValues.value;
                callback(null, BigInt(newAllowance));
                return [2 /*return*/];
            });
        }); });
        // DEV_NOTE : O.L : This was taken directly from the old 'orbs-pos-data'.
        //                  it seems that the contracts generated types are using the nodejs 'EventEmitter' type.
        //                  we should check for inconsistencies.
        // TODO : O.L : Ensure this works properly
        // @ts-ignore
        return function () { return erc20EventsUtils_1.getUnsubscribePromise(specificEventEmitter); };
    };
    // WRITE //
    OrbsTokenService.prototype.approve = function (spenderAddress, amount) {
        return this.erc20TokenContract.methods.approve(spenderAddress, amount.toString()).send();
    };
    return OrbsTokenService;
}());
exports.OrbsTokenService = OrbsTokenService;
//# sourceMappingURL=OrbsTokenService.js.map